// removed by extract-text-webpack-plugin
module.exports = {"navbar":"Navbar__navbar__3hzWU","container":"Navbar__container__12_g_","logoLink":"Navbar__logoLink__1mvpe","Hamburger":"Navbar__Hamburger__JR1_P","navigation":"Navbar__navigation__3jN2d"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navbar/Navbar.css
// module id = 72
// module chunks = 0